import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ApontamentoMotivoParada from "model/meta/producao/ApontamentoMotivoParada";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import Produto from "model/administracao/cadastro/produto/Produto";
import Pessoa from "model/administracao/cadastro/Pessoa";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import Usuario from "model/administracao/cadastro/Usuario";
import MotivoParada from "model/meta/producao/MotivoParada";

class ApontamentoMotivoParadaService implements BaseServiceCadastros<ApontamentoMotivoParada> {
    

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/apontamentoMotivoParada/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ApontamentoMotivoParada>((resolve, reject): void => {
            api
                .get(`/apontamentoMotivoParada/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(apontamentoMotivoParada: ApontamentoMotivoParada) {
        return new Promise<ApontamentoMotivoParada>((resolve, reject): void => {
            api
                .post(`/apontamentoMotivoParada/incluir`, JSON.stringify(apontamentoMotivoParada))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(apontamentoMotivoParada: ApontamentoMotivoParada) {
        return new Promise<ApontamentoMotivoParada>((resolve, reject): void => {
        });
    }

    editarApontamento(apontamento: ApontamentoMotivoParada) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/apontamentoMotivoParada/app/editar`;
            api
                .put(url, apontamento)
                .then(response => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/apontamentoMotivoParada/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/apontamentoMotivoParada/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/apontamentoMotivoParada/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    operacoes() {
        return new Promise<OperacaoProducao[]>((resolve, reject): void => {
            api
                .get(`/apontamentoMotivoParada/operacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/apontamentoMotivoParada/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    getMotivos() {
        return new Promise<MotivoParada[]>((resolve, reject): void => {
            let url = `/apontamentoMotivoParada/app/motivos`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ApontamentoMotivoParadaService;